import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import Navbar from '../shared/Navbar';

const ResetPasswordPage: React.FC<{ activation?: boolean }> = ({ activation = false }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState<string | null>(
    token ? null : 'This link is missing its token.'
  );
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    if (password !== confirmation) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      if (activation) {
        await api.activateAccount(token, password);
      } else {
        await api.resetPassword(token, password);
      }
      navigate('/dashboard', { replace: true });
    } catch (caught: any) {
      setError(caught?.message || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <Navbar />
      <main className="app-main">
        <div className="content-container auth-container">
          <div className="tm-surface auth-card">
            <h2 className="auth-title">{activation ? 'Welcome to TeachMeNow' : 'Reset Password'}</h2>
            <p className="auth-subtitle">
              {activation ? 'Create your password to activate your account and sign in.' : 'Choose a new password to reset it and sign in.'}
            </p>
            <form onSubmit={onSubmit} className="login-form">
              <div className="form-row">
                <label htmlFor="new-password">New password</label>
                <input
                  id="new-password"
                  type="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                  disabled={loading || !token}
                />
              </div>
              <div className="form-row">
                <label htmlFor="confirm-password">Confirm new password</label>
                <input
                  id="confirm-password"
                  type="password"
                  autoComplete="new-password"
                  value={confirmation}
                  onChange={(event) => setConfirmation(event.target.value)}
                  required
                  disabled={loading || !token}
                />
              </div>
              {error && <div className="ml-error">{error}</div>}
              <button
                type="submit"
                className="tm-button tm-button--primary ml-replace-btn auth-submit"
                disabled={loading || !token}
              >
                {loading ? 'Saving…' : activation ? 'Create password and sign in' : 'Reset password and sign in'}
              </button>
              <div className="auth-links">
                {activation
                  ? <p>Link expired? Ask your organisation admin to send another invitation.</p>
                  : <Link to="/forgot-password">Request another link</Link>}
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPasswordPage;
